export default {
  title:
    "Découvrez enfin votre potentiel <blockquote class='bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-yellow-400'>solaire</blockquote>",
  tc: "L'inscription vaut acceptation des <a class='text-indigo-600' href='/help/guides/installers/legal/mentions-legales#0'>conditions générales</a>, et notre <a class='text-indigo-600' href='/help/guides/installers/legal/declaration-de-confidentialite'>déclaration de confidentialité</a>.",
  "already-registered": "Déjà chez projetsolaire ? ",
  "type-select": "Vous êtes...",
  "company-name": "Votre raison sociale",
  "company-legal-name": {
    placeholder: "Entrez le nom légal de votre enprise",
    label: "Nom légal de l'entreprise",
  },
  siret: {
    label: "Entrez votre siret",
    placeholder: "SIRET",
    validation: "Siret est composé de 14 chiffres",
  },
  "company-representative-firstname": {
    placeholder: "Entrez le prénom du responsable de votre entreprise",
    label: "Prénom du représentant de la entreprise",
  },
  "company-representative-lastname": {
    placeholder: "Entrez le nom du responsable de votre entreprise",
    label: "Nom du représentant de l'entreprise",
  },
  "company-representative-email": {
    placeholder: "Entrez l'email du responsable de votre entreprise",
    label: "Email du représentant de l'entreprise",
  },
  "enter-your-company-name": "Entrez votre raison sociale",
  "password-confirm": "Confirmez votre mot de passe",
  email: {
    placeholder: "Entrez votre email",
    label: "Email",
    "verify-your-email": "Vérifiez votre email",
    "please-check-your-email": "Veuillez consulter votre email pour obtenir un lien de vérification",
    "resend": "Si vous ne recevez pas l'email de confirmation immédiatement, veuillez vérifier vos courriers indésirables. Si vous ne l'avez toujours pas reçu, cliquez sur « Renvoyer » ci-dessous.",
  },
  password: {
    "secure-password": "Mot de passe sécurisé",
    "description": "Vous utiliserez ce mot de passe ainsi que votre email pour vous connecter sur tous vos appareils.",
    placeholder: "Entrez votre mot de passe",
    label: "Mot de passe",
    required: "Le mot de passe est requis",
    "min-length": "Le mot de passe doit contenir au moins 8 caractères",
    "upper-case": "Le mot de passe doit contenir au moins une lettre majuscule",
    "lower-case": "Le mot de passe doit contenir au moins une lettre minuscule",
    symbol:
      "Le mot de passe doit contenir au moins un caractère spécial ($!%*?&)",
    number: "Le mot de passe doit contenir au moins un chiffre",
    "no-double-quote":
      'Le mot de passe ne peut pas contenir le caractère guillemet (")',
  },
  "confirm-password": {
    placeholder: "Confirmez votre mot de passe",
    label: "Confirmation mot de passe",
    "should-match": "Mots de passe doivent correspondre",
  },
  "phone-number": {
    label: "Numéro de téléphone",
    placeholder: "0-00-00-00-00",
  },
  "title-of-user": {
    label: "Civilité",
    type: {
      mr: "Monsieur",
      mrs: "Madame",
      miss: "Mademoiselle",
    },
  },
  firstname: {
    label: "Entrez votre prénom",
    placeholder: "Votre prénom",
  },
  lastname: {
    label: "Entrez votre nom",
    placeholder: "Votre nom",
  },
  dob: {
    label: "Entrez votre date de naissance",
    placeholder: "Votre date de naissance",
  },
  pob: {
    label: "Entrez votre lieu de naissance",
    placeholder: "Votre lieu de naissance",
  },
  type: {
    label: "Type d'utilisateur",
    description: "Quel type d'utiilsateur êtes-vous ?",
    residential: "Résidentiel",
    business: "Business",
    householder: "Propriétaire",
    installer: "Professionnel",
  },
  "required-field": {
    type: "Veuillez sélectionnez un type d'utilisateur",
    email: "Veuillez entrez votre adresse email",
    dob: "Veuillez entrez votre date de naissance",
    pob: "Veuillez entrez votre lieu de naissance",
  },
  success: {
    title:
      "Bienvenue ! Veuillez consulter votre email avant de pouvoir accéder à projetsolaire.",
    description:
      'Veuillez consulter votre boîte mail afin de confirmer la création de votre compte. Si vous ne voyez pas l\'email de confirmation tout de suite, veuillez vérifier votre dossier "spam" ou "courrier indésirable" et marquez-le "non-spam". Le message de confirmation s\'y retrouve parfois par erreur. Si vous avez une question n\'hésitez pas à nous contacter par courrier électronique.',
  },
  callback: {
    success: {
      title: "Inscription réussie",
      description: "L'email de votre compte a été validé avec succès",
    },
    "resend-email-success": {
      title: "Email d'activation envoyé",
      description:
        "Un nouvel email d'activation a été envoyé. Consulter votre boîte de réception pour activer votre compte.",
    },
    errors: {
      "token-invalid": "Votre lien d'activation est invalide",
      "token-missing": "Votre lien d'activation est invalide",
      "token-expired": "Votre lien d'activation a expiré",
      title: "Il y a eu un problème...",
      button:"Retour à la page d'accueil"
    },
    invites: {
      installer: {
        title:
          "Vous êtes invité par {installerCompanyName} pour rejoindre votre équipe solaire",
        description:
          "Veuillez confirmer l’invitation pour créer votre compte à vous et obtenir l’accès à l’espace professionnel de {installerCompanyName} en ligne.",
        button: "Initialiser votre mot de passe",
      },
      user: {
        title:
          "{installerCompanyName} vous a invité à suivre l'avancement en ligne de votre projet solaire.",
        description:
          "Veuillez renseigner un mot de passe pour créer votre compte et obtenir l'accès à votre espace personnel.",
        button: "Accéder à mon espace personnel",
      },
      lead: {
        title: "Vous avez été invité à rejoindre la plate-forme projetsolaire",
        description:
          "Merci de bien vouloir crée votre compte en cliquant sur le boutton ci-dessous afin d’accéder à votre espace personnel.",
        button: "Créer mon compte",
      },
    },
    buttons: {
      "resend-callback-link": "Renvoyer un lien d'activation",
      "send-callback-link": "Envoyer un lien d'activation",
    },
    verifying:{
      title:"Nous vérifions qu'il s'agit bien de vous...",
      description:"Nous vérifions actuellement votre accès, veuillez patienter..."
    }
  },
  errors: {
    duplicateEmailEnabled: "Votre email est associé à un compte existant.",
    duplicateEmailNotEnabled:
      "Votre email est associé à un compte existant mais non activé. Veuillez vérifier votre boite de réception.",
    "account-not-enabled":
      "Un installateur a déjà commencé un projet en votre nom. Vous pouvez accéder à votre projet en demandant un lien d'activation. Il ne vous restera plus qu'à activer votre compte et définir votre mot de passe avec le lien reçu par email.",
    "account-not-enabled-description":
      "Votre email est associé à un compte existant mais non activé. Veuillez vérifier votre boîte de réception.",
    unknown: "Une erreur est survenue.",
  },
  "email-sent": {
    title: "Email d'activation envoyé",
    description:
      "Un nouvel email d'activation a été envoyé. Consultez votre boîte de réception pour activer votre compte.",
  },
  enable: {
    callback: {
      title: "Définir votre mot de passe",
      "description-1":
        "« Pour protéger vos informations, il est nécessaire de choisir et d’utiliser des mots de passe robustes, c’est-à-dire difficiles à retrouver à l’aide d’outils automatisés et à deviner par une tierce personne »",
      "description-2": "www.interieur.gouv.fr",
      "confirm-password": "Valider votre mot de passe",
    },
  },
  "existing-siret": {
    title: "Félicitations votre établissement a déjà un compte !",
    description:
      "Le SIRET {siret} de l’entreprise est déjà enregistré auprès de projetsolaire.",
    button: "Connectez-vous",
  },
  "already-have-an-account": "Déjà un compte ?",
  "your-needs": "Configuration  du compte",
  "company-info": "Invitation de l’équipe",
  "team-invitation": "Invitation de l'équipe",
  "questions": "Une question ?",
  "book-a-demo": "Réserver une démo",
  "get-started": "Démarrez votre projet solaire",
  "account-created": {
    title: "Ouverture du compte réussie",
    success: "Email vérifiée avec succès",
    description: "Vous avez créé votre compte avec succès et pouvez maintenant poursuivre la configuration du compte.",
  },
  "which-one-are-you": "Lequel êtes-vous ?",
  "whats-your-email-address": "Quelle est votre adresse e-mail ?",
  "nice-to-meet-you": "Enchanté !",
  "whats-your-phone-number": "Quel est votre numéro de téléphone ?",
  "whats-your-legal-name": "Quel est votre nom légal?",
  "whats-your-company-information": "Quel est votre informations l'entreprise?",
  "pv-magazine-testimonial": "« L'équipe est vraiment à l'écoute de mes demandes pour améliorer l'application. L'application s'améliore toutes les semaines. »",
};
